// SHUTTERSTOCK IMAGE
export const SHUTTERSTOCK_POSITION_ID = "shutterstock";
export const SHUTTERSTOCK_POSITION_NAME = "Bild-Perfomance Report";
export const SHUTTERSTOCK_POSITION_DESCRIPTION =
  "Lizenzbilder Paket mit Performance Report & Insights";
export const SHUTTERSTOCK_POSITION_PRICE_PER_UNIT = 12;

// SHUTTERSTOCK VIDEO
export const SHUTTERSTOCK_POSITION_ID_VIDEO = "shutterstock-video";
export const SHUTTERSTOCK_POSITION_NAME_VIDEO = "Video-Perfomance Report";
export const SHUTTERSTOCK_POSITION_DESCRIPTION_VIDEO =
  "Lizenzvideo-Paket mit Leistungsbericht und Einblicken";
export const SHUTTERSTOCK_POSITION_PRICE_PER_UNIT_VIDEO = 24;

export const ANALYSIS_OPTIMIZATION_VIDEO_REVIEW_POSITION_ID = "analysis-optimization";
export const ANALYSIS_OPTIMIZATION_VIDEO_REVIEW_POSITION_NAME =
  "Analyse der Kampagnen-Performance während der Laufzeit";
export const ANALYSIS_OPTIMIZATION_VIDEO_REVIEW_POSITION_DESCRIPTION =
  "Performance Review der Kampagnen erfolgt nach der Lernphase, die je nach Plattform meist 7 oder 10 Tage dauert. Im Anschluss erhalten die Kunden ein Video mit Tipps und Vorschlägen zur Optimierung";

export const ANALYSIS_FEEDBACK_VIDEO_REVIEW_POSITION_ID = "analysis-feedback";
export const ANALYSIS_FEEDBACK_VIDEO_REVIEW_POSITION_NAME =
  "Abschluss Analyse der Kampagnen-Performance";
export const ANALYSIS_FEEDBACK_VIDEO_REVIEW_POSITION_DESCRIPTION =
  "Nach Ende der Kampagne wird die Performance analysiert. Sie erhalten hilfreiches Feedback für die nächste Kampagne";

export const SPOTIFY_HUMAN_VOICE_POSITION_ID = "spotify-human-voice";
export const SPOTIFY_HUMAN_VOICE_POSITION_NAME = "Professionelles Einsprechen für Spotify";
export const SPOTIFY_HUMAN_VOICE_POSITION_DESCRIPTION =
  "Ihr Anzeigentext wird exklusiv von Spotify Mitarbeitenden eingesprochen. Sie erhalten den Clip innerhalb von 3 Werktagen.";

export const CAMPAIGN_ITEM_ID = "campaign";
export const CAMPAIGN_ITEM_NAME = "Kampagne";

export const HUMAN_VIDEO_ITEM_ID = "human-video";
export const HUMAN_VIDEO_ITEM_NAME = "Spotify Video";
